query LookupSectionNameSearch(
  $travelSectionId: UUID!
  $orderBy: [LookupNamesOrderBy!]
  $lookupName: String!
) {
  lookupSectionNameSearch(
    travelSectionId: $travelSectionId
    orderBy: $orderBy
    lookupName: $lookupName
  ) {
    nodes {
      lookupName
      lookupDescription
      id
      lookupCode
      _isDeletable
      address1
      address2
      city
      state
      zipCode
      country
      countryId
      stateRegionId
      phone
    }
  }
}
